import {createSlice} from "@reduxjs/toolkit";

const initialRecallingResourcesState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: null,
  loadData: null,
  recallingResourceForEdit: undefined,
  listApplications: undefined,
  lastError: null
};
export const callTypes = {
  list: "list",
  action: "action"
};

export const recallingResourcesSlice = createSlice({
  name: "recallingResources",
  initialState: initialRecallingResourcesState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    recallingResourcesLoadedData: (state, action) => {
      state.error = null;
      state.loadData = action.payload.loadData;
      state.actionsLoading = false;
    },
    // getRecallingResourceById
    recallingResourceFetched: (state, action) => {
      state.actionsLoading = false;
      state.recallingResourceForEdit = action.payload.recallingResourceForEdit;
      state.error = null;
    },
    listApplicationsFetched: (state, action) => {
      state.actionsLoading = false;
      state.listApplications = action.payload.list;
      state.listLoading = false;
      state.error = null;
    },
    listApplicationsRecalled: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
    },
    // findRecallingResources
    recallingResourcesFetched: (state, action) => {
      const { totalCount, list } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = list;
      state.totalCount = totalCount;
    },
    // createRecallingResource
    recallingResourceCreated: (state, action) => {
      state.ewactionsLoading = false;
      state.error = null;
      state.entities.push(action.payload.recallingResource);
    },
    // updateRecallingResource
    recallingResourceUpdated: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.map(entity => {
        if (entity.id === action.payload.recallingResource.id) {
          return action.payload.recallingResource;
        }
        return entity;
      });
    },
    // deleteRecallingResource
    recallingResourceDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      // state.entities = state.entities.filter(el => el.id !== action.payload.id);
    },
    // deleteRecallingResources
    recallingResourcesDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.filter(
        el => !action.payload.ids.includes(el.id)
      );
    },
    // recallingResourcesUpdateState
    recallingResourcesStatusUpdated: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      const { ids, status } = action.payload;
      state.entities = state.entities.map(entity => {
        if (ids.findIndex(id => id === entity.id) > -1) {
          entity.status = status;
        }
        return entity;
      });
    }
  }
});
